export const redirectToApp = (url: string | URL): void => {
    window.location.assign(url);
};
